/* Tap fixes (v7, 5 Oct 2026) — from the Clarity dead-click review.
   1. Tap a photo → it opens large. Tap a small video → it opens large. Tap a full-width video → pause / play.
   2. Jump links (#finder, #fit …) stop with the heading below the sticky menu, not under it.
   3. Tapping the menu link for the page you're already on scrolls back to the top.
   4. Phones: the Chat button waits until you scroll past the first screen, so it doesn't cover the buttons. */
(function () {
  var d = document, root = d.documentElement;

  /* ---------- 0 · tag our own visits so reports can leave them out ----------
     Open any page once with ?ag_internal=1 on each of your devices (?ag_internal=0 undoes it).
     Automated test browsers are tagged too. Clarity then has a tag "internal = yes" to filter on. */
  try {
    var m = location.search.match(/[?&]ag_internal=([01])/);
    if (m) { if (m[1] === '1') localStorage.setItem('ag_internal', '1'); else localStorage.removeItem('ag_internal'); }
    var internal = localStorage.getItem('ag_internal') === '1' || navigator.webdriver === true;
    if (internal) {
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('set', 'internal', 'yes');
      root.classList.add('ag-internal');
    }
  } catch (x) {}

  /* ---------- 2 · sticky-menu offset for jump links ---------- */
  function stickyH() {
    var h = 0;
    d.querySelectorAll('header, nav, .bar, .tabs, [class*="chrome"]').forEach(function (el) {
      var s = getComputedStyle(el);
      if (s.position !== 'sticky' && s.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.height < 240 && r.top <= 2) h = Math.max(h, r.bottom);
    });
    return Math.round(h);
  }
  function setPad() { root.style.scrollPaddingTop = (stickyH() + 12) + 'px'; }
  setPad(); addEventListener('load', setPad); addEventListener('resize', setPad);

  /* ---------- 3 · menu link to the page you're on → back to top ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (u.origin === location.origin && u.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '') && !u.hash && u.search === location.search && a.closest('header, nav, .bar, .tabs')) {
      e.preventDefault();
      scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  /* ---------- 1 · tap to enlarge / pause ---------- */
  var css = d.createElement('style');
  css.textContent =
    '.ag-zoom{cursor:zoom-in}' +
    'dialog.ag-lb{border:0;padding:0;margin:0;width:100vw;height:100vh;height:100dvh;max-width:none;max-height:none;background:rgba(18,16,12,.92);display:flex;align-items:center;justify-content:center}' +
    'dialog.ag-lb:not([open]){display:none}dialog.ag-lb::backdrop{background:rgba(18,16,12,.92)}' +
    '.ag-lb img,.ag-lb video{max-width:94vw;max-height:86vh;max-height:86dvh;width:auto;height:auto;border-radius:10px;display:block;object-fit:contain}' +
    '.ag-lb button{position:absolute;top:max(12px,env(safe-area-inset-top));right:12px;width:48px;height:48px;border-radius:50%;border:0;background:#fff;color:#211e16;font:700 28px/1 system-ui,sans-serif;cursor:pointer}' +
    '.ag-lb p{position:absolute;bottom:max(14px,env(safe-area-inset-bottom));left:0;right:0;text-align:center;color:#fff;font:600 14px/1.3 system-ui,sans-serif;opacity:.8;margin:0;padding:0 16px}' +
    '.ag-vbadge{position:absolute;z-index:5;left:50%;top:50%;transform:translate(-50%,-50%);background:rgba(18,16,12,.7);color:#fff;border-radius:999px;padding:10px 16px;font:700 15px/1 system-ui,sans-serif;pointer-events:none;transition:opacity .4s}' +
    '@media (max-width:760px){html:not(.ag-scrolled) shopify-chat{visibility:hidden}}';
  d.head.appendChild(css);

  var SKIP = 'a, button, label, summary, select, input, textarea, header, footer, .bar, .tabs, .brand, .logos, .plogo, .lbwrap, .ag-lb, [role="button"], [role="dialog"], .needsclick, [class*="kl-private"], form, [data-sc-scrub]';
  function clickableAncestor(el) {
    for (var n = el, i = 0; n && n !== d.body && i < 4; n = n.parentElement, i++) {
      if (getComputedStyle(n).cursor === 'pointer') return true;
    }
    return false;
  }
  function eligible(el) {
    if (!el || (el.tagName !== 'IMG' && el.tagName !== 'VIDEO')) return false;
    if (el.closest(SKIP)) return false;
    if (el.hasAttribute('controls')) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 140 || r.height < 100) return false;
    if (el.tagName === 'IMG' && (/logo|icon|mark|badge/i.test(el.currentSrc || el.src) || clickableAncestor(el))) return false;
    return true;
  }

  var lb = null;
  function openLb(node, caption) {
    if (!lb) {
      lb = d.createElement('dialog');
      lb.className = 'ag-lb';
      lb.setAttribute('aria-label', 'Enlarged view');
      lb.addEventListener('click', function () { lb.close(); });
      lb.addEventListener('close', function () { setTimeout(function () { if (!lb.open) lb.innerHTML = ''; }, 0); });
      d.body.appendChild(lb);
    }
    lb.innerHTML = '';
    var b = d.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Close'); b.textContent = '×';
    lb.appendChild(node); lb.appendChild(b);
    if (caption) { var p = d.createElement('p'); p.textContent = caption; lb.appendChild(p); }
    try { lb.showModal(); } catch (x) { lb.setAttribute('open', ''); }
  }
  function bigSrc(img) {
    var best = img.currentSrc || img.src, bw = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (c) {
      var m = c.trim().split(/\s+/), w = parseInt(m[1], 10) || 0;
      if (m[0] && w > bw) { bw = w; best = m[0]; }
    });
    return best;
  }
  function badge(v, text) {
    var host = v.parentElement; if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var old = host.querySelector(':scope > .ag-vbadge'); if (old) old.remove();
    var s = d.createElement('span'); s.className = 'ag-vbadge'; s.textContent = text;
    host.appendChild(s);
    setTimeout(function () { s.style.opacity = '0'; }, 700);
    setTimeout(function () { s.remove(); }, 1200);
  }

  d.addEventListener('pointerover', function (e) {
    var t = e.target;
    if (t && !t.classList.contains('ag-zoom') && eligible(t)) t.classList.add('ag-zoom');
  }, { passive: true });

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (e.defaultPrevented || !eligible(t)) return;
    if (t.tagName === 'IMG') {
      /* Shop pop-up photos: use the pop-up's own full-screen viewer so people can swipe through every photo */
      var agLb = d.getElementById('agLb'), group = t.closest('dialog.pp') && (t.closest('.strip, .slides, .thumbs, .pic') || t.parentElement);
      if (agLb && agLb.__open && group) {
        var imgs = [].slice.call(group.querySelectorAll('img')).filter(function (x) { return x.getBoundingClientRect().width >= 60; });
        var srcs = imgs.map(bigSrc), at = Math.max(0, imgs.indexOf(t));
        if (srcs.length) { agLb.__open(srcs, at); return; }
      }
      var im = d.createElement('img');
      im.src = bigSrc(t); im.alt = t.alt || '';
      openLb(im, t.alt || '');
    } else {
      var wide = t.getBoundingClientRect().width >= innerWidth * 0.8;
      if (wide) {
        if (t.paused) { var p = t.play(); if (p && p.catch) p.catch(function () {}); badge(t, '▶ Playing'); }
        else { t.pause(); badge(t, '❚❚ Paused · tap to play'); }
      } else {
        var v = d.createElement('video');
        v.src = t.currentSrc || t.src; v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true;
        ['muted', 'loop', 'autoplay', 'playsinline'].forEach(function (a) { v.setAttribute(a, ''); });
        if (t.poster) v.poster = t.poster;
        openLb(v, t.getAttribute('aria-label') || '');
        var q = v.play(); if (q && q.catch) q.catch(function () {});
      }
    }
  });

  /* ---------- 4 · phones: show Chat after the first screen ---------- */
  function onScroll() {
    if (scrollY > innerHeight * 0.6) { root.classList.add('ag-scrolled'); removeEventListener('scroll', onScroll); }
  }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
})();
